import React, { FC, ReactNode } from 'react';
import styles from './Alert.module.scss';

interface AlertProps {
  title?: string;
  description: ReactNode;
  className?: string;
}

const Alert: FC<AlertProps> = ({ title, description, className }: AlertProps) => {
  return (
    <div className={className ? `${styles.Alert} ${className}` : styles.Alert}>
      {title && <h3 className={styles.Title}>{title}</h3>}
      <div className={styles.Description}>{description}</div>
    </div>
  );
};

Alert.defaultProps = {
  title: undefined,
  className: undefined,
};

export default Alert;
